<script>
export default {
  props: {
    title: {
      default: "Box",
      type: String,
    },
    entry: {
      default: null,
      type: Object,
    },
    editable: {
      default: false,
      type: Boolean,
    },
    editing: {
      default: false,
      type: Boolean,
    },
  },
  watch: {
    $route() {
      this.$emit("editing", false);
    },
  },
};
</script>

<template>
  <div class="listingBox" :class="{ editing: editing }">
    <div class="box__head">
      <div class="toggle--collapse" @click="$emit('toggle-collapse')">
        <b-icon icon="chevron-down" />
        <div class="box__title" v-if="title">{{ title }}</div>
      </div>
      <div class="right" v-if="editable">
        <b-button
          class="toggle--edit"
          :type="editing ? 'is-warning' : 'is-link'"
          rounded
          size="is-small"
          @click="$emit('editing', !editing)"
          v-text="editing ? 'Cerrar' : 'Editar'"
        />
      </div>
    </div>
    <div class="box__body">
      <slot />
    </div>
  </div>
</template>
